/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-12-31 15:16:48                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2024-12-31 17:02:18                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * CompInfoInputPassword: Password compinfo component
*/

/* Imports */
import { EyeIcon } from "@heroicons/react/24/solid";
import { useRef } from "react";
/***/

/**
* CompInfoInputPassword: Password compinfo component
* @param value - current value
* @param onChange - on value change event
* @param className - Additional classname
*/
export default function CompInfoInputPassword({
  value,
  onChange,
  className = ""
}: {
  value: string,
  onChange: (data: string) => void,
  className?: string
}) {
  const ref = useRef<HTMLInputElement>(null);

  /**
  * showHidePassword: hide or show password 
  */
  const showHidePassword = () => {
    if (ref && ref.current) {
      ref.current.type = ref.current.type === "password" ? "text" : "password";
    }
  };
  /***/

  return (
    <>
      <div className="relative">
        <input  type="password"
                placeholder="ex: ..."
                value={value}
                ref={ref}
                className={`form-field ${className}`}
                onChange={(el) => onChange(el.target.value)}/>

        <button className="absolute right-3 p-1 top-[50%] translate-y-[-50%] text-slate-500"
                onClick={() => showHidePassword()}>
          <EyeIcon className="w-4 h-4"/>
        </button>
      </div>
    </>
  );
}
/***/
